<template>
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 2H2m0 4.53h4M2 11h4m5.039 3L11 6m0 0L8 9m3-3l3 3"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
